import { DevelopmentalData } from "@/types/developmental";

export const age3Milestones: DevelopmentalData = {
  motor: [
    "Climbs well",
    "Pedals tricycle",
    "Walks up/down stairs alternating feet",
    "Catches bounced ball",
    "Copies circles and crosses"
  ],
  language: [
    "Uses 3-4 word sentences",
    "Understands most speech",
    "Answers simple questions",
    "Uses pronouns correctly",
    "Tells simple stories"
  ],
  cognitive: [
    "Names basic colors",
    "Understands counting to 5",
    "Draws person with 2-4 body parts",
    "Plays make-believe with toys",
    "Understands time concepts"
  ],
  independent: [
    "Uses toilet independently",
    "Dresses with minimal help",
    "Brushes teeth with help",
    "Pours from small pitcher",
    "Helps with simple chores"
  ],
  social: [
    "Takes turns in games",
    "Shows concern for others",
    "Plays cooperatively",
    "Separates easily from parents",
    "Expresses feelings verbally"
  ]
};